import { Button, type ButtonProps } from "@medimo/ui";
import { signOut } from "aws-amplify/auth";

export const SignOutButton = ({ onClick, ...props }: ButtonProps) => {
  return (
    <Button
      onClick={async (e) => {
        await signOut();
        onClick?.(e);
      }}
      {...props}
    />
  );
};
